import axios from 'axios';

const api_login = process.env.REACT_APP_API_URL+"/api/login";
const api_login_admin = process.env.REACT_APP_API_URL+"/api/login/admin";
const api_register = process.env.REACT_APP_API_URL+"/api/register";
const api_register_admin = process.env.REACT_APP_API_URL+"/api/register/admin";
const api_validateUser = process.env.REACT_APP_API_URL+"/api/validation/user";

function register(username, password) {
    return axios
        .post(api_register, 
            {
                'database': 'imperiumcloud',
                'collection': 'astartes',
                'username': username,
                'password': password
            }
        )
        .then((response) => {
            if (response.data.success) {
                localStorage.setItem("user", JSON.stringify(response.data.info));
            }
            return response.data
        })
        .catch((error)=>{});
}

function login(username, password) {
    return axios
        .post(api_login, 
            {
                'database': 'imperiumcloud',
                'collection': 'astartes',
                'username': username,
                'password': password
            }
        )
        .then((response) => { 
            if (response.data.success) {
                localStorage.setItem('user', JSON.stringify(response.data.info));
            }
            return response.data;
        })
        .catch((error)=>{});
}

function registerAdmin(username, password) {
    return axios
        .post(api_register_admin, 
            {
                'database': 'imperiumcloud',
                'collection': 'astartes',
                'username': username,
                'password': password
            }
        )
        .then((response) => { 
            if (response.data.success) {
                localStorage.setItem('user', JSON.stringify(response.data.info));
            }
            return response.data;
        })
        .catch((error)=>{});
}

function loginAdmin(username, password) {
    return axios
        .post(api_login_admin, 
            {
                'database': 'imperiumcloud',
                'collection': 'astartes',
                'username': username,
                'password': password
            }
        )
        .then((response) => { 
            if (response.data.success) {
                localStorage.setItem('user', JSON.stringify(response.data.info));
            }
            return response.data;
        })
        .catch((error)=>{});
}

function checkUsername(username) {    
    return axios
        .post(api_validateUser, 
            {
                'database': 'imperiumcloud',
                'collection': 'astartes',
                'username': username
            }
        )
        .then((response) => {
            return response.data;
        })
        .catch((error)=>{});
}

function logout() {
    localStorage.removeItem("user");
}

function getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
}

const Authentication = {
    register,
    registerAdmin,
    checkUsername,
    login,
    loginAdmin,
    logout,
    getCurrentUser
}
export default Authentication;